"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFiles = initFiles;
const file_app_svg_1 = __importDefault(require("./assets/image/files/file-app.svg"));
const file_audio_svg_1 = __importDefault(require("./assets/image/files/file-audio.svg"));
const file_doc_svg_1 = __importDefault(require("./assets/image/files/file-doc.svg"));
const file_external_svg_1 = __importDefault(require("./assets/image/files/file-external.svg"));
const file_image_svg_1 = __importDefault(require("./assets/image/files/file-image.svg"));
const file_stream_svg_1 = __importDefault(require("./assets/image/files/file-stream.svg"));
const file_unknown_svg_1 = __importDefault(require("./assets/image/files/file-unknown.svg"));
const file_video_svg_1 = __importDefault(require("./assets/image/files/file-video.svg"));
const file_zip_svg_1 = __importDefault(require("./assets/image/files/file-zip.svg"));
function initFiles() {
    const filesContainer = document.querySelector('.files');
    filesContainer.style.position = 'fixed';
    filesContainer.style.left = '0';
    filesContainer.style.top = '0';
    filesContainer.style.width = '100vw';
    filesContainer.style.height = '100vh';
    filesContainer.style.perspective = '800px';
    filesContainer.style.perspectiveOrigin = 'center';
    filesContainer.style.pointerEvents = 'none';
    const options = [
        file_app_svg_1.default,
        file_audio_svg_1.default,
        file_doc_svg_1.default,
        file_external_svg_1.default,
        file_image_svg_1.default,
        file_stream_svg_1.default,
        file_unknown_svg_1.default,
        file_video_svg_1.default,
        file_zip_svg_1.default,
    ].map(icon => generateHangingOptionFor(icon));
    filesContainer.append(...createBatchIconFromOptions(options));
}
function generateHangingOptionFor(icon) {
    const padding = 200;
    const xBegin = padding;
    const xEnd = window.innerWidth - padding;
    const yBegin = padding;
    const yEnd = window.innerHeight - padding;
    return {
        icon,
        x: Math.random() * (xEnd - xBegin) + xBegin,
        y: Math.random() * (yEnd - yBegin) + yBegin,
        z: Math.random() * 1000
    };
}
function createBatchIconFromOptions(opts) {
    return opts.map(opt => createHangingIcon(opt));
}
function createHangingIcon(opt) {
    const domNode = document.createElement('div');
    domNode.style.position = 'absolute';
    domNode.style.left = '0';
    domNode.style.top = '0';
    domNode.style.width = '0';
    domNode.style.height = '100%';
    // domNode.style.borderRight = '1px solid #ddd'
    domNode.style.transformOrigin = 'center';
    domNode.className = 'swing-item';
    domNode.style.animationDelay = `${(Math.random() * 5).toFixed(1)}s`;
    domNode.style.animationDuration = `${(Math.random() * 5) + 5}s`;
    const imageDomNode = createFileIcon(opt);
    domNode.appendChild(imageDomNode);
    const wrapperDomNode = document.createElement('div');
    wrapperDomNode.style.position = 'absolute';
    wrapperDomNode.style.left = `${opt.x}px`;
    wrapperDomNode.style.top = '0';
    wrapperDomNode.style.width = '0';
    wrapperDomNode.style.height = `${opt.y}px`;
    wrapperDomNode.style.transformOrigin = 'top center';
    wrapperDomNode.className = 'swing-line';
    wrapperDomNode.style.animationDelay = `${(Math.random() * 2).toFixed(1)}s`;
    wrapperDomNode.style.animationDuration = `${(Math.random() * 5) + 5}s`;
    wrapperDomNode.appendChild(domNode);
    return wrapperDomNode;
}
function createFileIcon(opt) {
    const fileIcon = document.createElement('img');
    fileIcon.style.position = 'absolute';
    fileIcon.style.left = '50%';
    fileIcon.style.bottom = '0';
    fileIcon.style.width = '24px';
    fileIcon.style.height = '24px';
    fileIcon.style.opacity = '.2';
    fileIcon.style.transform = 'translateX(-50%) translateY(24px)';
    fileIcon.src = opt.icon;
    fileIcon.title = 'support file';
    return fileIcon;
}
